import React, { useState, useEffect } from "react";
import Layout from "../../../layout";
import { toast } from 'react-toastify';
import LoaderSvg from '../../../../assets/images/loader.svg'
import { Link } from "react-router-dom";
import { validateField } from '../../../../util/helpers'
import { addJobService, updateJobService } from '../../../../config/jobs';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const AddJob = ({ edit = false, activeItem = false, setCloseModal = () => { }, onGetAllJobs = () => { } }) => {
    const [title, setTitle] = useState("")
    const [location, setLocation] = useState("")
    const [jobType, setJobType] = useState("")
    const [desc, setDesc] = useState(EditorState.createEmpty())
    const [descText, setDescText] = useState("")

    const [loader, setLoader] = useState(false)

    const onEditorStateChange = (editorState) => {
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        const markup = draftToHtml(rawContentState)
        setDesc(editorState)
        setDescText(markup)
    }


    // const navigate = useNavigate()
    useEffect(() => {
        if (edit) {

            setTitle(activeItem.title)
            setJobType(activeItem.jobType)
            setLocation(activeItem.location)
            // setDesc("hello")
            let descTe = EditorState.createWithContent(
                ContentState.createFromBlockArray(
                    convertFromHTML(activeItem.desc)
                )
            )
            setDesc(descTe)
            setDescText(descTe)


        }
    }, [])

    const onSubmit = async (e) => {

        e.preventDefault();
        let validate = true

        if (title.trim() === "") {
            validateField("title", "Title field is required")
            validate = false
        }
        if (location.trim() === "") {
            validateField("location", "Location field is required")
            validate = false
        }
        if (jobType.trim() === "") {
            validateField("jobType", "Job Type field is required")
            validate = false
        }

        if (descText.trim() === "") {
            validateField("descText", "Description field is required")
            validate = false
        }

        if (!validate) {
            toast("Please fill required fields")
            return
        }

        try {
            setLoader(true)
            let fd = new FormData()
            let data = {
                title,
                location,
                jobType,
                desc: descText,
            }

            for (let key in data) {
                fd.append(key, data[key])
            }
            const res = await addJobService(fd)

            if (res.data.status) {
                toast("Job Added Successfully")
                setLoader(false)
                setTitle("")
                setLocation("")
                setJobType("")
                setDesc("")
                // navigate("/news")

            }
        }
        catch (err) {
            setLoader(false)
            console.log(err)

        }
    }
    const onUpdate = async (e) => {

        e.preventDefault();
        let validate = true

        if (title.trim() === "") {
            validateField("title", "Title field is required")
            validate = false
        }
        if (desc.length == 0) {
            validateField("desc", "Description field is required")
            validate = false
        }

        if (!validate) {
            toast("Please fill required fields")
            return
        }

        try {
            setLoader(true)
            const res = await updateJobService({
                _id: activeItem._id,
                title,
                location,
                jobType,
                desc: descText,

            })

            if (res.data.status) {

                setLoader(false)
                setCloseModal(false)
                toast("Job Updated Successfully")
                onGetAllJobs()
            }
        }
        catch (err) {
            setLoader(false)
            console.log(err)

        }
    }



    const render = () => {
        return (
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            {!edit &&
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <h4 class="card-title">Add Job</h4>
                                    </div>
                                    <div className='col-md-6 text-end'>

                                    </div>
                                </div>
                            }

                            <form class="forms-sample" onSubmit={(e) => { edit ? onUpdate(e) : onSubmit(e) }}>
                                <div class="form-group">
                                    <label for="exampleInputUsername1">Title</label>
                                    <input type="text" class="form-control" id="exampleInputUsername1" placeholder="Title" value={title} name="title" onChange={(e) => { setTitle(e.target.value); }} />
                                </div>

                                <div class="form-group">
                                    <label for="exampleInputUsername1">Location</label>
                                    <input type="text" class="form-control" id="exampleInputUsername1" placeholder="Location" value={location} name="location" onChange={(e) => { setLocation(e.target.value); }} />
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputUsername1">Job Type</label>
                                    <input type="text" class="form-control" id="exampleInputUsername1" placeholder="Job Type" value={jobType} name="jobType" onChange={(e) => { setJobType(e.target.value); }} />
                                </div>

                                <div class="form-group">
                                    <label>Description</label>
                                    <Editor
                                        // name="desc"
                                        wrapperClassName="wrapper-class wrapperClassName"
                                        editorClassName="editor-class"
                                        toolbarClassName="toolbar-class"
                                        editorState={desc}
                                        onEditorStateChange={onEditorStateChange}

                                    />
                                </div>

                                <button type="submit" class="btn btn-primary me-2">{loader ? <img src={LoaderSvg} style={{ padding: "0 7px" }} /> : "Submit"}</button>
                                {/* <button class="btn btn-light">Cancel</button> */}
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
    return !edit ? (
        <Layout header="Add New Job" sideBtn={<Link to="/jobs/add-job" class="add btn btn-primary todo-list-add-btn" > Go Back</Link>}>

            {render()}
        </Layout >
    ) :
        render()

}

export default AddJob;